<template>
    <b-modal :id="id" :title="title" class="" size="xl" @click:outside="closeModal()">
        <div class="embed-responsive embed-responsive-16by9">
            <embed v-if="!!file" :type="type" :src="file" :style="{ 'width': '100%', 'height': responsiveHeighType() }" />
        </div>
        <template #modal-footer>
            <b-btn variant="outline-secondary" @click="close()"> Fechar </b-btn>
        </template>
    </b-modal>
</template>
<style lang="css" scoped>
.modal-content {
    background-color: transparent !important;
}

.embed-responsive {
    overflow: auto !important;
}
</style>
<script>
export default {
    data() {
        return {
            type: "",
        };
    },
    watch: {
        id(newVal, oldVal) {
            if (newVal != oldVal) this.getFile();
        },
    },
    props: {
        id: "",
        title: "",
        file: "",
    },
    methods: {
        responsiveHeighType() {

            let type = this.file.split(".");

            var result = "auto";
            switch (type.pop()) {
                case "jpg":
                case "jpeg":
                case "png":
                case "gif":
                    result = "auto";
                    break;
                case "pdf":
                case "xls":
                case "xlsx":
                case "doc":
                case "docx":
                    result = "100%";
                    break;

            }

            return result;
        },
        close() {
            this.$bvModal.hide(this.id);
        },
        getFile() {
            var xhr = new XMLHttpRequest();
            xhr.open("HEAD", this.file, true);

            xhr.onload = function () {
                var contentType = xhr.getResponseHeader("Content-Type");
                this.type = contentType;
                console.log(contentType);
            };

            xhr.send();
        },
    },
};
</script>
